import apiRoutes from '../constants/apiRoutes';
import baseApi from '../services/api';

export interface InvestorContributionSplit {
  id: string;
  investor: string;
  contributionPercentage: number;
  returnCap: number;
}

export interface Deal {
  gameId: string;
  startDate: string; // format: YYYY-MM-DD
  endDate: string; // format: YYYY-MM-DD
  pricingMethodology: 'SIMPLE_INTEREST' | string;
  underspentInterest: number;
  interest: string;
  status: 'ACTIVE' | string;
  cohortMonth: number;
  createdBy: string;
  createdByEmail: string;
  createdAt: string;
  investorContributionSplits: InvestorContributionSplit[];
}

interface GameDetailsApi {
  code: number;
  data: Deal[];
  message: string;
}

export interface DealDetailsRequestPayload {
  gameId: string;
  startDate: string | null; // ISO date string format: "YYYY-MM-DD"
  endDate: string | null; // ISO date string format: "YYYY-MM-DD"
  pricingMethodology: string;
  underspentInterest: number | null;
  interest: Record<string, any>;
  status: string;
  cohortMonth: number | null;
  investorContributionSplits: {
    investor: string;
    contributionPercentage: number;
    returnCap: number;
  }[];
}

const deals = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDeals: builder.query<GameDetailsApi, { gameId: string; isActive?: boolean }>({
      query: ({ gameId, isActive }: { gameId: string; isActive?: boolean }) =>
        `${apiRoutes.deals}/games/${gameId}${isActive ? `?isActive=true` : `?isActive=false`}`,
    }),
    dealDetails: builder.mutation<any, DealDetailsRequestPayload>({
      query: (payload) => ({
        url: `${apiRoutes.deals}`,
        method: 'POST',
        body: payload,
      }),
    }),
  }),
});

export const { useLazyGetDealsQuery, useDealDetailsMutation } = deals;
